import { createRequestTypes } from '../utils';

export const TOX_PROFILE_CHAPTER_LIST = createRequestTypes('toxProfileChapter/LIST_CHAPTERS');
